import {Card, CardContent, Grid, Typography, useTheme} from "@mui/material";
import {TrendCard} from "../../pages/MatchupTeamsPage/components/TrendCard";
import {ActiveTrend} from "../../../types/nbaTypes";
import {getNbaSeason, getNcaafbSeason, getNflSeason} from "../../../utils/timeUtils";
import {LoadingSkeleton} from "../../atoms/LoadingSkeleton/LoadingSkeleton";
import {useCallback} from "react";
import {useAuth} from "../../../AuthContext/authContext";

export const TrendCardsColumn = (
    {trends, sport, loading}:
        {trends: ActiveTrend[], sport: string, loading: boolean}
) => {
    let seasonToUse = getNbaSeason()
    const {loggedInUserEmail} = useAuth()
    const theme = useTheme()
    let labelToUse = sport;
    if(sport === 'ncaabb') labelToUse = 'ncaa bb'
    if(sport === 'ncaafb') labelToUse = 'ncaa fb'
    if(sport === 'nfl') seasonToUse = getNflSeason()
    if(sport === 'ncaafb') seasonToUse = getNcaafbSeason()

    const notLoggedInCard = useCallback(() => {
        return (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Card
                    sx={{
                        width: '100%',
                        maxHeight: '200px'
                    }}
                >
                    <CardContent sx={{
                        maxWidth: '100%',
                    }}>
                        <Typography
                            variant="caption"
                            component="p"
                            align="center"
                        >
                            Log in to see trends
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
        )
    }, [])

    const emptyTrendsCard = useCallback(() => {
        return (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Card
                    sx={{
                        width: '100%',
                        maxHeight: '200px',
                        marginBottom: '12px',
                    }}
                >
                    <CardContent sx={{maxWidth: '100%'}}>
                        <Typography
                            variant="caption"
                            component="p"
                            align="center"
                        >
                            No Homepage Trends Saved
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
        )
    }, [])

    if(loading) {
        return (
            <Grid
                item
                container
                xs={12}
                sm={12}
                md={4}
                lg={4}
                xl={4}
                display='flex'
                flexDirection='column'
            >
                <LoadingSkeleton height={300} width={'97%'} />
                <LoadingSkeleton height={300} width={'97%'} />
            </Grid>
        )
    }
    const noTrendsToShow = loggedInUserEmail ? emptyTrendsCard() : notLoggedInCard()

    return (
        <Grid
            item
            container
            // columnGap={2}
            xs={5}
            sm={5}
            md={2}
            lg={4}
            xl={4}
            mt={3.5}
            display='flex'
            flexDirection={{ xs: 'row', md: 'row', lg: 'column' }}
            alignContent="flex-start"
            flexWrap="wrap"
        >
            <Typography
                variant="caption"
                component="p"
                align="center"
                width={'100%'}
                color={theme.palette.grey[500]}
                mb={.5}
            >
                {labelToUse.toUpperCase()} Trends
            </Typography>
            <Grid container spacing={1} flexWrap="wrap">
                {
                    (trends?.length > 0) ? trends?.map((trend: ActiveTrend, index: number) =>
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6} key={index} mb={'8px'}>
                            <TrendCard
                                sport={sport}
                                trend={trend}
                                fullWidth={true}
                            />
                        </Grid>
                    ) : noTrendsToShow
                }
            </Grid>
        </Grid>
    )
}